<div class="edit-user">
  <div class="container">
    <div class="d-flex justify-content-between container" *ngIf="isInitialised">
      <h2>
        {{ contactName }}
      </h2>
      <div>
        <button
          type="button"
          (click)="router.navigateByUrl('/contacten')"
          class="btn btn-main btn-back"
        >
          <mat-icon svgIcon="close"></mat-icon>
        </button>
      </div>
    </div>
    <div *ngIf="isInitialised">
      <div>
        <form
          [formGroup]="contactForm"
          role="form"
          autocomplete="off"
          id="formCompanyEdit"
          novalidate=""
          (submit)="save()"
        >
          <mat-card class="mat-elevation-z0 padding">
            <div class="form-title font-weight-bold">Algemeen</div>
            <div class="d-flex justify-content-between width-50">
              <mat-form-field class="form-field no-margin" appearance="outline">
                <mat-label>Aanhef</mat-label>
                <mat-select placeholder="Aanhef" formControlName="gender">
                  <mat-option
                    *ngFor="let salutation of salutations"
                    [value]="salutation.value"
                  >
                    {{ salutation.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field
                class="form-field left-margin"
                appearance="outline"
              >
                <mat-label>Functie</mat-label>
                <mat-select placeholder="Functie" formControlName="type">
                  <mat-option *ngFor="let type of types" [value]="type.value">
                    {{ type.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="d-flex justify-content-between">
              <mat-form-field class="no-margin form-field" appearance="outline">
                <mat-label>Voornaam</mat-label>
                <input
                  matInput
                  type="text"
                  required
                  formControlName="firstName"
                  [placeholder]="'Voornaam'"
                />
              </mat-form-field>
              <mat-form-field
                class="form-field left-margin"
                appearance="outline"
              >
                <mat-label>Achternaam</mat-label>
                <input
                  matInput
                  type="text"
                  required
                  formControlName="lastName"
                  [placeholder]="'Achternaam'"
                  required
                />
              </mat-form-field>
            </div>

            <div class="d-flex justify-content-between">
              <mat-form-field class="no-margin form-field" appearance="outline">
                <mat-label>Telefoonnummer</mat-label>
                <input
                  matInput
                  type="text"
                  formControlName="telephone"
                  [value]="
                    contactForm.controls.telephone.value | asFormatPhoneNumber
                  "
                  [placeholder]="'Telefoonnummer'"
                />
              </mat-form-field>
              <mat-form-field
                class="form-field left-margin"
                appearance="outline"
              >
                <mat-label>Gsm nummer</mat-label>
                <input
                  matInput
                  type="text"
                  formControlName="mobile"
                  [value]="
                    contactForm.controls.mobile.value | asFormatPhoneNumber
                  "
                  [placeholder]="'Gsm'"
                />
              </mat-form-field>
            </div>

            <div class="d-flex justify-content-between">
              <div class="d-flex flex-column no-margin form-field">
                <mat-form-field
                  class="no-margin form-field"
                  appearance="outline"
                >
                  <mat-label>E-mailadres</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="email"
                    [placeholder]="'E-mailadres'"
                  />
                </mat-form-field>

                <mat-form-field style="width: 50%" appearance="outline">
                  <mat-label>Geboortedatum</mat-label>
                  <input
                    matInput
                    formControlName="birthdate"
                    [matDatepicker]="birthdate"
                    placeholder="Selecteer een datum"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="birthdate"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #birthdate></mat-datepicker>
                </mat-form-field>
              </div>

              <mat-form-field
                class="form-field left-margin"
                appearance="outline"
              >
                <mat-label>Persoonlijke info contact</mat-label>
                <textarea
                  matInput
                  formControlName="personalInfo"
                  [placeholder]="'Persoonlijke info contact'"
                  rows="5"
                ></textarea>
              </mat-form-field>
            </div>

            <div class="d-flex" style="width: 50%">
              <button
                *ngIf="isAdminLoggedIn && email.email && contactUser == null"
                type="button"
                (click)="createClientCornerUser()"
                mat-button
                class="inline-button"
                [disabled]="contactHasLogin"
              >
                Login aanmaken
              </button>
              <button
                *ngIf="contactUser"
                type="button"
                (click)="navigateToContactUser()"
                mat-button
                class="inline-button"
              >
                Ga naar gebruiker
              </button>
              <button
                *ngIf="isAdminLoggedIn && contactUser != null"
                class="inline-button smaller-left-space"
                type="button"
                (click)="resendLoginEmail()"
                mat-button
              >
                Login mail opnieuw versturen
              </button>
            </div>

            <div class="form-title font-weight-bold">Bedrijven</div>

            <div *ngIf="companies == null || companies.length === 0">
              <p class="no-margin padding-bottom">
                Geen bedrijven gedefinieerd
              </p>
            </div>
            <div
              *ngIf="companies != null && companies.length > 0"
              class="table-container panel"
            >
              <div class="example-table-container">
                <table
                  mat-table
                  [dataSource]="companies"
                  class="example-table"
                  matSort
                  matSortActive="id"
                  matSortDisableClear="true"
                  matSortDirection="asc"
                >
                  <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef class="header-text">
                      <div class="d-flex">
                        <div class="text-middle" [mat-sort-header]="">
                          <b>Naam</b>
                        </div>
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let row" class="table-text">
                      {{ row.regularName
                      }}<span *ngIf="!row.dataCorrect"
                        >&nbsp;&nbsp;<mat-icon
                          matTooltip="Bedrijf nog niet vervolledigd"
                          class="data-not-correct-icon"
                          >report_problem</mat-icon
                        ></span
                      >
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="phone">
                    <th mat-header-cell *matHeaderCellDef class="header-text">
                      <div class="d-flex">
                        <div class="text-middle" [mat-sort-header]="">
                          <b>Telefoonnummer</b>
                        </div>
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let row" class="table-text">
                      {{ row.telephones[0] && row.telephones[0].number }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="email">
                    <th mat-header-cell *matHeaderCellDef class="header-text">
                      <div class="d-flex">
                        <div class="text-middle extra-right">
                          <b>Email</b>
                        </div>
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let row" class="table-text">
                      <a
                        *ngIf="
                          row.emails?.length > 0 && row.emails[0].email != null
                        "
                        class="click-link"
                        href="mailto:{{ row.emails[0].email }}"
                        (click)="$event.stopPropagation()"
                        >{{ row.emails[0].email }}</a
                      >
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr
                    [routerLink]="['/bedrijven', row.id]"
                    mat-row
                    class="table-row clickable"
                    *matRowDef="let row; columns: displayedColumns"
                  ></tr>
                </table>
              </div>
            </div>
            <button
              *ngIf="contact.id != null"
              type="button"
              (click)="openCompanyContactDialog()"
              mat-button
              class="inline-button"
              id="btnEditContacts"
            >
              Bewerk bedrijven
            </button>
          </mat-card>
        </form>
        <div class="float-right">
          <button
            type="button"
            (click)="save()"
            mat-button
            class="button"
            id="btnLogin"
          >
            Opslaan
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
